import { render, staticRenderFns } from "./PhoValidationProvider.vue?vue&type=template&id=699e593a&lang=pug"
import script from "./PhoValidationProvider.vue?vue&type=script&lang=js"
export * from "./PhoValidationProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports